<template>
  <div class="box-wrapper">
    <div class="box-content">
      <div class="mt-4 mb-4 text-center">
        <h4 class="title">{{ $t("ERROR.SERVER_NOT_RESPONDING") }}</h4>
        <b-button variant="primary" :to="{ name: 'Login' }">{{
          $t("BACK")
        }}</b-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {},
  computed: {},
  mounted() {},
};
</script>
<style></style>
